import { useContext } from 'react'
import { ModalContext } from '../ModalContext'

export default function VideoPlayerModal() {
    const { modalData } = useContext(ModalContext)

    return (
        <div className="h-full overflow-auto space-y-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
            <h1 className="text-lg font-semibold text-gray-900">{modalData.title}</h1>
            
            <div className='overflow-hidden rounded-lg bg-gray-100 flex justify-center'>
                {modalData.videoUrl && modalData.videoUrl.trim() !== '' ? (
                    <video 
                        width="720" 
                        height="400" 
                        controls
                        playsInline 
                        loop
                        x-webkit-airplay="deny"
                        onError={(e) => {
                            console.error('Video playback error:', e);
                        }}
                        className="w-full max-w-4xl h-auto"
                        style={{ maxHeight: '70vh' }}
                    >
                        <source src={modalData.videoUrl} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                ) : (
                    <div className="flex items-center justify-center h-64 text-gray-500 w-full">
                        No video available for this exercise
                    </div>
                )}
            </div>

            {modalData.description && modalData.description.length > 0 && (
                <div className="p-4 bg-gray-100 rounded-xl text-left text-sm text-gray-700">
                    {modalData.description}
                </div>
            )}
        </div>
    )
}
